import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belaumtobagalkotcab() {



    const cardData = {




keyword: "Belgaum to Bagalkot Cab",

headingDescription: "Belgaum Taxi Service provides reliable and comfortable Belgaum to Bagalkot cab services for family travel, business trips, pilgrimage tours, educational visits, medical travel, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Bagalkot, we offer safe and affordable transportation with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your travel requirements. Our services include doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth and convenient journey. Belgaum Taxi Service connects passengers between Belgaum and Bagalkot for personal, corporate, religious, and tourist travel with comfortable and hassle-free cab solutions.",

topPlaces: [
  {
    title: "Badami",
    description: "Badami is a famous heritage destination near Bagalkot known for its ancient cave temples, sandstone cliffs, Agastya Lake, and remarkable Chalukyan architecture."
  },
  {
    title: "Aihole",
    description: "Aihole is a historic village known for its ancient temples and unique architectural structures. It is a popular destination for history lovers and educational tours."
  },
  {
    title: "Pattadakal",
    description: "Pattadakal is a UNESCO World Heritage Site famous for its beautifully designed temples and historical monuments, attracting tourists from across Karnataka."
  },
  {
    title: "Kudalasangama",
    description: "Kudalasangama is an important pilgrimage destination known for the Krishna and Malaprabha river confluence and the Basavanna temple."
  },
  {
    title: "Bijapur",
    description: "Bijapur is a historic city famous for Gol Gumbaz, ancient monuments, and cultural heritage. It is a popular destination for sightseeing and family trips."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's major IT and business hub, known for technology parks, corporate offices, and commercial centers. Long-distance cab services provide comfortable connectivity."
  },
  {
    title: "Pune",
    description: "Pune is an important IT, education, and industrial city in Maharashtra. Travelers prefer private cabs for convenient interstate journeys."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital with major business districts, airports, and tourist attractions. Comfortable outstation cabs are preferred for long-distance travel."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination famous for beaches, resorts, churches, and sightseeing places. Private cabs provide a comfortable travel option for vacation trips."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage destination known for ancient ruins, temples, and historical landscapes, making it a preferred tourist destination in Karnataka."
  }
],




"services": [
  {
    "name": "Belgaum to Bagalkot Cab",
    "description": "Book Belgaum to Bagalkot Cab for safe, comfortable, and reliable intercity travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for family trips, business travel, sightseeing, and personal journeys with flexible one way and round trip options."
  },
  {
    "name": "Belgaum to Bagalkot Taxi",
    "description": "Choose Belgaum to Bagalkot Taxi for convenient and affordable transportation between cities. Enjoy comfortable seating, experienced drivers, clean vehicles, transparent pricing, and hassle-free booking facilities for smooth travel."
  },
  {
    "name": "Belgaum to Bagalkot Cab Service",
    "description": "Our Belgaum to Bagalkot Cab Service provides reliable travel solutions with professional chauffeurs and premium vehicles. Get comfortable AC cabs for personal trips, corporate travel, family journeys, and outstation transportation."
  },
  {
    "name": "Belgaum to Bagalkot Taxi Service",
    "description": "Book Belgaum to Bagalkot Taxi Service for safe and convenient city-to-city travel. Experience timely pickup, experienced drivers, affordable fares, and multiple vehicle options for a comfortable journey."
  },
  {
    "name": "Belgaum to Bagalkot One Way Cab",
    "description": "Hire Belgaum to Bagalkot One Way Cab for economical single-trip travel without return charges. Enjoy fixed pricing, doorstep pickup, comfortable AC cars, and professional driver services."
  },
  {
    "name": "Belgaum to Bagalkot Cab Booking",
    "description": "Complete Belgaum to Bagalkot Cab Booking with easy online reservations, quick confirmation, and flexible travel options. Select from different car categories according to your comfort and budget."
  },
  {
    "name": "Belgaum to Bagalkot Car Rental",
    "description": "Choose Belgaum to Bagalkot Car Rental for private chauffeur-driven travel with well-maintained vehicles. Get Sedan, SUV, Ertiga, and Innova Crysta options for comfortable and convenient journeys."
  },
  {
    "name": "Belgaum to Bagalkot Outstation Cab",
    "description": "Book Belgaum to Bagalkot Outstation Cab for long-distance travel with experienced chauffeurs and reliable vehicles. Perfect for family tours, business trips, personal travel, and customized outstation requirements."
  },
  {
    "name": "Belgaum to Bagalkot Airport Cab",
    "description": "Reserve Belgaum to Bagalkot Airport Cab for smooth airport transportation with punctual pickup and drop services. Travel comfortably with professional drivers and spacious AC vehicles."
  },
  {
    "name": "Belgaum to Bagalkot Airport Taxi",
    "description": "Choose Belgaum to Bagalkot Airport Taxi for reliable airport transfer services with affordable fares and timely travel solutions. Enjoy convenient booking and comfortable rides for passengers and families."
  },
  {
    "name": "Belgaum to Bagalkot Innova Crysta Cab",
    "description": "Book Belgaum to Bagalkot Innova Crysta Cab for premium travel comfort with spacious interiors, luxury seating, and experienced chauffeurs. Ideal for family trips, corporate journeys, airport transfers, and group travel."
  },
  {
    "name": "Belgaum to Bagalkot Ertiga Cab",
    "description": "Choose Belgaum to Bagalkot Ertiga Cab for spacious 6 to 7 seater travel with affordable pricing and comfortable seating. Perfect for family outings, group transportation, and outstation journeys."
  },
  {
    "name": "Belgaum to Bagalkot Sedan Cab",
    "description": "Book Belgaum to Bagalkot Sedan Cab for economical and comfortable travel with clean AC cars and professional drivers. Suitable for business trips, personal rides, and long-distance transportation."
  },
  {
    "name": "Belgaum to Bagalkot Round Trip Cab",
    "description": "Hire Belgaum to Bagalkot Round Trip Cab for flexible return travel with affordable packages and experienced chauffeurs. Ideal for sightseeing, family visits, business meetings, and planned journeys."
  },
  {
    "name": "Belgaum to Bagalkot Private Taxi",
    "description": "Choose Belgaum to Bagalkot Private Taxi for exclusive chauffeur-driven transportation with privacy, comfort, and flexible schedules. Enjoy personalized travel solutions for families, professionals, and groups."
  },
  {
    "name": "Cheap Belgaum to Bagalkot Cab",
    "description": "Book Cheap Belgaum to Bagalkot Cab with affordable fares, reliable vehicles, and professional driver services. Enjoy budget-friendly travel without compromising safety and comfort."
  },
  {
    "name": "Best Belgaum to Bagalkot Cab Service",
    "description": "Choose the Best Belgaum to Bagalkot Cab Service offering premium vehicles, skilled chauffeurs, competitive pricing, and dependable transportation solutions for every travel requirement."
  },
  {
    "name": "Online Belgaum to Bagalkot Cab Booking",
    "description": "Complete Online Belgaum to Bagalkot Cab Booking with simple reservations, instant confirmation, transparent pricing, and multiple vehicle choices. Get convenient taxi booking anytime."
  },
  {
    "name": "Belgaum to Bagalkot Taxi Fare",
    "description": "Check Belgaum to Bagalkot Taxi Fare with affordable travel packages and flexible vehicle options. Select Sedan, Ertiga, Innova Crysta, or SUV cabs based on your journey requirements."
  },
  {
    "name": "Cabs Service in Bagalkot",
    "description": "Book Cabs Service in Bagalkot for reliable local and outstation travel with professional drivers and comfortable vehicles. Get convenient taxi solutions for airport transfers, family trips, business travel, and nearby destinations."
  }
],
"tableData": [
  ["Belgaum to Bagalkot Cab", "Belgaum to Bagalkot Taxi"],
  ["Belgaum to Bagalkot Cab Service", "Belgaum to Bagalkot Taxi Service"],
  ["Belgaum to Bagalkot One Way Cab", "Belgaum to Bagalkot Cab Booking"],
  ["Belgaum to Bagalkot Car Rental", "Belgaum to Bagalkot Outstation Cab"],
  ["Belgaum to Bagalkot Airport Cab", "Belgaum to Bagalkot Airport Taxi"],
  ["Belgaum to Bagalkot Innova Crysta Cab", "Belgaum to Bagalkot Ertiga Cab"],
  ["Belgaum to Bagalkot Sedan Cab", "Belgaum to Bagalkot Round Trip Cab"],
  ["Belgaum to Bagalkot Private Taxi", "Cheap Belgaum to Bagalkot Cab"],
  ["Best Belgaum to Bagalkot Cab Service", "Online Belgaum to Bagalkot Cab Booking"],
  ["Belgaum to Bagalkot Taxi Fare", "Cabs Service in Bagalkot"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Bagalkot Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service provides comfortable Belgaum to Bagalkot cab services with professional drivers, clean vehicles, and reliable transportation for business and personal journeys."
  },
  {
    WhyChooseheading: "Convenient Pickup from Belgaum",
    WhyChoosedescription: "Get doorstep pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and nearby areas with direct drop at your preferred location in Bagalkot."
  },
  {
    WhyChooseheading: "Wide Range of Cab Options",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and other comfortable vehicles based on your travel needs."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Service",
    WhyChoosedescription: "Book a one-way Belgaum to Bagalkot cab or select a round-trip taxi package with flexible timings and convenient travel options."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Journey",
    WhyChoosedescription: "Our professional chauffeurs are familiar with the Belgaum to Bagalkot route and ensure a smooth, safe, and comfortable travel experience."
  },
  {
    WhyChooseheading: "Affordable Belgaum to Bagalkot Taxi Fare",
    WhyChoosedescription: "Enjoy competitive taxi fares with transparent pricing, customized packages, and no hidden charges for your outstation journey."
  },
  {
    WhyChooseheading: "Ideal for Family & Business Travel",
    WhyChoosedescription: "Our Belgaum to Bagalkot cabs are suitable for family trips, office visits, medical travel, sightseeing, and personal transportation."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Reserve your Belgaum to Bagalkot taxi anytime with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Bagalkot Cab Service?",
    answer: "Yes, we provide reliable Belgaum to Bagalkot cab services with comfortable vehicles and experienced drivers."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Bagalkot?",
    answer: "Yes, one-way taxi services are available with pickup from any location in Belgaum."
  },
  {
    question: "Which vehicles are available for Belgaum to Bagalkot travel?",
    answer: "We offer Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and other comfortable cab options."
  },
  {
    question: "Do you provide airport pickup and drop service from Belgaum?",
    answer: "Yes, we provide pickup and drop facilities from Belgaum Airport to Bagalkot and nearby destinations."
  },
  {
    question: "Is Belgaum to Bagalkot cab service available 24/7?",
    answer: "Yes, our taxi services are available throughout the day for your preferred travel schedule."
  },
  {
    question: "Can I book a return cab from Bagalkot to Belgaum?",
    answer: "Yes, return and round-trip taxi services are available with flexible travel timings."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless included in the confirmed quotation."
  },
  {
    question: "Is this cab service suitable for family travel?",
    answer: "Yes, our Belgaum to Bagalkot taxi service offers comfortable travel options for families, groups, and individual passengers."
  },
  {
    question: "Can I book a private taxi from Belgaum to Bagalkot?",
    answer: "Yes, we provide private cab services with dedicated vehicles and professional drivers for a comfortable journey."
  },
  {
    question: "How can I book a Belgaum to Bagalkot Cab?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Kulkarni",
    feedback: "The Belgaum to Bagalkot cab service was very comfortable. The driver was punctual, the vehicle was clean, and the entire journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Patil",
    feedback: "We booked a taxi from Belgaum to Bagalkot and had a great experience. The service was reliable, affordable, and professionally managed.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Bagalkot Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-bagalkot-cab.webp",
  "description":
    "Book Belgaum to Bagalkot Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Bagalkot with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, business trips, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-bagalkot-cab"
  }
};






    return (
        <div>
<Helmet>
  <title>Belgaum to Bagalkot Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Bagalkot Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Bagalkot with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Bagalkot Cab, Belgaum to Bagalkot Taxi, Belgaum to Bagalkot Cab Service, Belgaum to Bagalkot Taxi Service, Belgaum to Bagalkot One Way Cab, Belgaum to Bagalkot Cab Booking, Belgaum to Bagalkot Car Rental, Belgaum to Bagalkot Outstation Taxi, Belgaum to Bagalkot One Way Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belaumtobagalkotcab;